import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ChatScreen from "@/components/ChatScreen";
import VendorDashboard from "@/components/VendorDashboard";
import AdminDashboard from "@/components/AdminDashboard";
import VendorLanding from "@/components/VendorLanding";
import VendorVerify from "@/components/VendorVerify";
import VoiceAgent from "@/components/VoiceAgent";
import { useAssistantChat } from "@/hooks/useAssistantChat";

function ChatPage() {
  const chat = useAssistantChat();
  return (
    <ChatScreen
      messages={chat.messages}
      isLoading={chat.isLoading}
      onSendMessage={chat.sendMessage}
      onSendButton={chat.sendButton}
      onSendLocation={chat.sendLocation}
      onSendVoice={chat.sendVoice}
      onSendImage={chat.sendImage}
      sessionId={chat.sessionId}
    />
  );
}

function VendorPage() {
  return <VendorDashboard />;
}

function App() {
  return (
    <BrowserRouter>
      <div className="app-container">
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/talk/:agent" element={<VoiceAgent />} />
          <Route path="/partners" element={<VendorLanding />} />
          <Route path="/vendor/join" element={<VendorLanding />} />
          <Route path="/vendor/verify/:token" element={<VendorVerify />} />
          <Route path="/vendor" element={<VendorPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
